// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"logo-codepen"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M2.5 15.15L12 8.50002M12 8.50002L21.5 15.15M12 8.50002V2.75002M21.5 8.85002L12 15.5M12 15.5L2.5 8.85002M12 15.5V21.5M2 15.5V8.5L12 2L22 8.5V15.5L12 22L2 15.5Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-logo-codepen')
export default class LogoCodepenIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-codepen',
    }
  }
}
